import React, { useState } from "react";
import axios from "axios";

import { useEffect } from "react";
import { ExcelExport } from "@progress/kendo-react-excel-export";
import { ExcelExportColumn } from "@progress/kendo-react-excel-export";
import { Grid, GridColumn } from "@progress/kendo-react-grid";

import { useLocation, Link, useNavigate } from "react-router-dom";
import Swal from "sweetalert2";
// import UnitUpdate2 from './dental_unit_update'
import {
  FaCashRegister,
  FaFileMedical,
  FaPenSquare,
  FaRegEdit,
  FaRegTrashAlt,
} from "react-icons/fa";
import Treatement from "../Treatment/Treatment";
import { confirmAlert } from "react-confirm-alert";
import "react-confirm-alert/src/react-confirm-alert.css";
import BASE_API_URL from "../../../../api/api";
import apiInstance from "../../../../Utils/api";
const Income = () => {
  const token = localStorage.getItem("token");
  const url = BASE_API_URL;
  // const url = 'http://192.168.1.15:9000/api/'
  const api = apiInstance;

  const navigate = useNavigate();

  const [treatmentLists, setTreatmentLists] = useState([]);
  const [filterLilst, setFilterList] = useState([]);
  const [showFilter, setShowFilter] = useState(false);
  const [showOri, setShowOri] = useState(true);
  const [expValue, setExpValue] = useState("");
  const [totalList, setTotalList] = useState([]);
  const [showExpValue, setShowExpValue] = useState(false);
  const [treatmentExcelLists, setTreatmentExcelLists] = useState([]);
  const TreatId = useLocation().pathname.split("/")[2];
  const handleFilter = (val) => {
    if (val) {
      setShowExpValue(true);
      setExpValue(val);
    }
  };

  const _export = React.useRef(null);
  const _export1 = React.useRef(null);

  const excelExport = () => {
    if (_export.current !== null) {
      // console.log(_export.current.props.data)
      _export.current.props.data.map(function (element, index) {
        element.date = element.date?.split("T")[0];
      });
      _export.current.save();
    }
  };

  const excelExport1 = () => {
    if (_export1.current !== null) {
      // console.log(_export1.current.props.data, 'total')
      _export1.current.props.data.map(function (element, index) {
        element.name = element.items.item_id.procedureItemName
          ? element.items.item_id.procedureItemName + "(Procedure Item)"
          : "" || element.items.item_id.accessoryItemName
            ? element.items.item_id.accessoryItemName + "(Accessory Item)"
            : "" || element.items.item_id.medicineItemName
              ? element.items.item_id.medicineItemName + "(Medicine Item)"
              : "";

        element.bigName = element.items.item_id.name.name;
        element.qty = element.items.quantity;
        element.titleName = element.title;
      });

      _export1.current.save();
    }
  };

  const handleSearch = (event) => {
    console.log(event, "event search");
    if (event) {
      setFilterList(
        treatmentLists.filter((el) => el.name.toLowerCase().includes(event)),
      );
      // console.log(
      //   treatmentLists.filter(el => (el.name ? el.name : '' == event)),
      //   'list filter'
      // )

      setShowFilter(true);
      setShowOri(false);
    } else {
      setShowFilter(false);
      setShowOri(true);
    }
  };
  const handleDelete = (event) => {
    api
      .delete("dental-treatment/" + event)
      .then((response) => {
        Swal.fire({
          title: "Success",
          text: "Successfully Deleted!",
          icon: "success",
          confirmButtonText: "OK",
        });
        const result = treatmentLists.filter((item) => item._id !== event);
        setTreatmentLists(result);
      })
      .catch((error) => {
        Swal.fire({
          title: "Error",
          text: error.response.data.message,
          icon: "error",
          confirmButtonText: "CANCEL",
        });
      });
  };
  const submit = (id) => {
    confirmAlert({
      title: "Confirm to delete!",
      message: "Are you sure to do this.",
      buttons: [
        {
          label: "Yes",
          onClick: () => handleDelete(id),
        },
        {
          label: "No",
          //onClick: () => alert('Click No')
        },
      ],
    });
  };

  useEffect(() => {
    const getTreatmentLists = async () => {
      try {
        const res = await api.get(
          "dental-treatments/list/" + TreatId,
          //'http://localhost:9000/api/treatments'
        );
        // setTreatmentLists(res.data.data, 'list')

        setTreatmentLists(res.data.data);
        // console.log(res.data.data, 'len')

        // console.log(res.data.data.sort((a, b) => a.treatmentCode?.split('-')[1] - b.treatmentCode?.split('-')[1]), 'treat list')
      } catch (err) {
        Swal.fire({
          title: "Error",
          text: "No record found, yet!",
          icon: "error",
          confirmButtonText: "CANCEL",
        });
      }
    };
    const getTreatmentExcel = async () => {
      try {
        const res = await api.get(
          "dental-treatment/excel/" + TreatId,
          //'http://localhost:9000/api/treatments'
        );
        // setTreatmentLists(res.data.data, 'list')

        setTreatmentExcelLists(res.data.list);
        // console.log(res.data.list, 'len')

        // console.log(res.data.list, 'treat excel list')
      } catch (err) {
        Swal.fire({
          title: "Error",
          text: "No record found, yet!",
          icon: "error",
          confirmButtonText: "CANCEL",
        });
      }
    };
    getTreatmentExcel();
    getTreatmentLists();
  }, []);

  return (
    <>

        <div className="content-wrapper">
          <div className="content-header">
            <div className="container-fluid">
              <div className="row mb-2">
                <div className="col-sm-12">
                  <ol className="breadcrumb">
                    <li className="breadcrumb-item">
                      <Link to="/dental-treatment">Back</Link>
                    </li>
                    <li className="breadcrumb-item active">
                      Dental Treatment Unit List
                    </li>
                  </ol>
                </div>
              </div>
            </div>
          </div>

          <section className="content">
            <div className="container-fluid">
              <div className="row d-flex justify-content-between mt-5">
                <div className="col-md-4">
                  <div className="row">
                    <div className="col-6">
                      <select
                        className="form-control"
                        onChange={(e) => handleFilter(e.target.value)}
                      >
                        <option hidden>Choose to Export</option>
                        <option value="normal">Normal List</option>
                        <option value="item">Items List</option>
                      </select>
                    </div>
                    {showExpValue ? (
                      expValue === "normal" ? (
                        <div className="col-6">
                          <button
                            className="btn btn-sm btn-success rounded-3 mt-1"
                            onClick={excelExport}
                          >
                            Export
                          </button>
                        </div>
                      ) : (
                        <div className="col-6">
                          <button
                            className="btn btn-sm btn-success rounded-3 mt-1"
                            onClick={excelExport1}
                          >
                            Export
                          </button>
                        </div>
                      )
                    ) : (
                      <div className="col-6">
                        <button
                          className="btn btn-sm btn-success rounded-3 mt-1"
                          onClick={excelExport}
                          disabled
                        >
                          Export
                        </button>
                      </div>
                    )}
                  </div>
                </div>

                {/* <div className='col-md-3'>
                 
                </div> */}

                <div className="offset-1 col-md-4 ml-4">
                  <div
                    className="input-group row ml-4"
                    style={{ marginBottom: "20px" }}
                  >
                    <div className="col-md-6">
                      <input
                        type="search"
                        className="form-control rounded ml-1"
                        style={{ borderRadius: "12px" }}
                        id="search_code"
                        placeholder="Search"
                        onChange={(e) => handleSearch(e.target.value)}
                      />
                    </div>
                    <div className="col-md-6 mt-1">
                      <Link
                        to={"/dental-check-create/" + TreatId}
                        className="btn  btn-primary"
                        style={{ borderRadius: "7px" }}
                      >
                        Create Unit
                      </Link>
                    </div>
                  </div>
                </div>
              </div>
              <div className="row">
                <div className="col-12">
                  <div className="card">
                    {/* <div className="card-header">
                      <div className="row justify-content-between">
                        <span className="float-right">
                          <a href="/income_type" className="btn btn-primary">
                            Income Type
                          </a>
                           <button
                              type="button"
                              className="btn btn-primary"
                              onClick={excelExport}>
                              Export Excel
                            </button>
                        </span>
                      </div>
                      <div className="row" id="trial_balance"></div>
                    </div> */}

                    <div className="card-body">
                      {/* Export data in Excel */}
                      {expValue === "normal" ? (
                        <ExcelExport
                          data={treatmentLists}
                          ref={_export}
                          filterable={true}
                          fileName="UnitList.xlsx"
                        >
                          <ExcelExportColumn
                            field=""
                            title="No"
                            locked={true}
                            width={30}
                          />

                          <ExcelExportColumn
                            field="dentalTreatmentCode"
                            title="Treatment Unit Code"
                            headerCellOptions={{
                              textAlign: "center",
                            }}
                            width={200}
                          />

                          <ExcelExportColumn
                            field="name"
                            title="Treatment Unit Name"
                            headerCellOptions={{
                              textAlign: "center",
                            }}
                            width={250}
                          />

                          <ExcelExportColumn
                            field="dentalTreatmentName.name"
                            title="Treatment Name"
                            headerCellOptions={{
                              textAlign: "center",
                            }}
                            width={200}
                          />
                          <ExcelExportColumn
                            field="dentalTreatmentTimes"
                            title="Treatment Times"
                            headerCellOptions={{
                              textAlign: "center",
                            }}
                            width={200}
                          />

                          <ExcelExportColumn
                            field="estimateTotalPrice"
                            title="Purchase Price"
                            headerCellOptions={{
                              textAlign: "center",
                            }}
                            width={250}
                          />

                          <ExcelExportColumn
                            field="sellingPrice"
                            title="Selling Price"
                            width={150}
                          />
                          <ExcelExportColumn
                            field="TCLEstimateTotalPrice"
                            title="TCL Total Price"
                            width={150}
                          />

                          <ExcelExportColumn
                            field="TCLSellingPrice"
                            title="TCL Selling Price"
                            width={150}
                          />

                          <ExcelExportColumn
                            field="description"
                            title="Description"
                            width={350}
                          />
                        </ExcelExport>
                      ) : (
                        <>
                          {/* <Grid
                            data={totalList}
                            // other grid configurations
                          >
                            <GridColumn field='name' title='Name' />
                            <GridColumn field='qty' title='Qty' />
                          </Grid> */}

                          <ExcelExport
                            data={treatmentExcelLists}
                            ref={_export1}
                            filterable={true}
                            fileName="ItemList.xlsx"
                          >
                            <ExcelExportColumn
                              field="no"
                              title="No"
                              locked={true}
                              width={30}
                            />

                            <ExcelExportColumn
                              field="titleName"
                              title="Treatment Unit Name"
                              headerCellOptions={{
                                textAlign: "center",
                              }}
                              width={250}
                            />
                            <ExcelExportColumn
                              field="name"
                              title="Items Name"
                              headerCellOptions={{
                                textAlign: "center",
                              }}
                              width={400}
                            />
                            {/* 
                            <ExcelExportColumn
                              field='hello.name'
                              title='Procedure Items Name'
                              headerCellOptions={{
                                textAlign: 'center'
                              }}
                              width={200}
                            />
                            <ExcelExportColumn
                              field=''
                              title='Accessory Items Name'
                              headerCellOptions={{
                                textAlign: 'center'
                              }}
                              width={200}
                            /> */}

                            <ExcelExportColumn
                              field="qty"
                              title="Qty"
                              width={150}
                              headerCellOptions={{
                                textAlign: "center",
                              }}
                            />
                          </ExcelExport>
                        </>
                      )}

                      {/* Export Data in Excel end */}
                      <div className="row">
                        <div className="col-md-12">
                          <div
                            className="table-responsive text-black"
                            id="slimtest2"
                          >
                            <table
                              className="table table-hover"
                              id="filter_date"
                            >
                              <thead className="bg-white text-white">
                                <tr>
                                  <th>#</th>
                                  <th>Code</th>
                                  <th>Name</th>
                                  <th>Times</th>
                                  {/* <th>Doctor</th> */}
                                  <th>Total Price</th>
                                  <th>Selling Price</th>
                                  <th>TCL Selling Price</th>
                                  <th>Description</th>
                                  {/* <th>Check</th> */}
                                  <th className="text-center">Action</th>
                                </tr>
                              </thead>
                              {showOri && (
                                <tbody>
                                  {treatmentLists.map((treatment, i) => (
                                    <tr>
                                      <td>{++i}</td>
                                      <td>
                                        {treatment.dentalTreatmentCode
                                          ? treatment.dentalTreatmentCode
                                          : ""}
                                      </td>
                                      <td>{treatment.name}</td>
                                      <td>{treatment.dentalTreatmentTimes}</td>
                                      {/* <td>
                                      {treatment.relatedDoctor
                                        ? treatment.relatedDoctor.name
                                        : ''}
                                    </td> */}
                                      <td>{treatment.estimateTotalPrice}</td>
                                      <td>{treatment.sellingPrice}</td>
                                      <td>{treatment.TCLSellingPrice}</td>

                                      <td>
                                        {treatment.description
                                          ? treatment.description
                                          : ""}
                                      </td>
                                      {/* <td className='text-center'>
                                      <Link to={'/detail/' + treatment._id}>
                                        <p className='btn btn-sm btn-info rounded'>
                                          Detail
                                        </p>
                                      </Link>
                                    </td> */}
                                      <td className="text-center">
                                        {/* <div>
                                        <UnitUpdate2 TreatId={TreatId} />
                                      </div> */}
                                        <Link
                                          to={`/dental-check-update/${treatment._id}/${TreatId}`}
                                          className="btn btn-sm btn-warning"
                                        >
                                          <FaRegEdit />
                                        </Link>
                                        &nbsp;
                                        <button
                                          className="btn btn-sm btn-danger"
                                          onClick={(e) => submit(treatment._id)}
                                        >
                                          <FaRegTrashAlt />
                                        </button>
                                      </td>
                                    </tr>
                                  ))}
                                </tbody>
                              )}
                              {showFilter && (
                                <tbody>
                                  {filterLilst.map((treatment, i) => (
                                    <tr>
                                      <td>{++i}</td>
                                      <td>
                                        {treatment.treatmentCode
                                          ? treatment.treatmentCode
                                          : ""}
                                      </td>
                                      <td>{treatment.name}</td>
                                      <td>{treatment.treatmentTimes}</td>
                                      {/* <td>
                                      {treatment.relatedDoctor
                                        ? treatment.relatedDoctor.name
                                        : ''}
                                    </td> */}
                                      <td>{treatment.estimateTotalPrice}</td>
                                      <td>{treatment.sellingPrice}</td>

                                      <td>
                                        {treatment.description
                                          ? treatment.description
                                          : ""}
                                      </td>
                                      {/* <td className='text-center'>
                                      <Link to={'/detail/' + treatment._id}>
                                        <p className='btn btn-sm btn-info rounded'>
                                          Detail
                                        </p>
                                      </Link>
                                    </td> */}
                                      <td className="text-center">
                                        {/* <div>
                                        <UnitUpdate2 TreatId={TreatId} />
                                      </div> */}
                                        <Link
                                          to={`/dental-check-update/${treatment._id}/${TreatId}`}
                                          className="btn btn-sm btn-warning"
                                        >
                                          <FaRegEdit />
                                        </Link>
                                        &nbsp;
                                        <button
                                          className="btn btn-sm btn-danger"
                                          onClick={(e) => submit(treatment._id)}
                                        >
                                          <FaRegTrashAlt />
                                        </button>
                                      </td>
                                    </tr>
                                  ))}
                                </tbody>
                              )}
                            </table>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              {/* <Treatement
                open={open}
                close={() => setOpen(false)}
                setTreatmentLists={setTreatmentLists}
                treatmentLists={treatmentLists}
              /> */}
            </div>
          </section>
        </div>

    </>
  );
};

export default Income;
